export const formContent2 = 'parts: {0} machine: 0';
export const formName = 'search results';
export const PCC_SEARCH_RESULTS = 'PCC Search Results';
